import { CostCenterService } from '../share/costCenter/costcenter.service';
import { CostCenter } from '../share/costCenter/costcenter.model';
import { Component, OnInit, Input } from '@angular/core';
import { QueryModel } from '../share/paginationquery.model';
import { ReportsService } from '../share/reports/report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PartialReport } from './partial-report.type';
import { finalize } from 'rxjs/operators';
import { AppSettings } from '../../settings';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-partial-report',
  templateUrl: './partial-report.component.html',
  styleUrls: ['./partial-report.component.scss'],
  providers: [ReportsService, CostCenterService]
})
export class PartialReportComponent implements OnInit {
  recordsPerPage: number;
  partialReports: PartialReport[] = [];
  costCenters: CostCenter[] = [];
  costCenterId: number;
  selectedDate: string;
  filterValue: string;
  currencySuffix: string;
  query: QueryModel = new QueryModel();
  currentPageNumber = 1;
  details = -1;
  isLoadDetails = false;
  order = 'name';
  lastSearchCostCenterId: number;

  constructor(
    private _reportsService: ReportsService,
    private _costCenterService: CostCenterService,
    private _spinner: NgxSpinnerService,
    private _translate: TranslateService,
    private _toastrService: ToastrService,
    private _settings: AppSettings
  ) {
    this.currencySuffix = _settings.defaultCurrency;
    this.recordsPerPage = _settings.recordsPerPage;
   }

  ngOnInit() {
    this.loadCostCentersItemsForDropdown();
  }

  sort(propertyName) {
    if (this.details > -1) return;
    if (this.order === propertyName) {
      this.order = '-' + propertyName;
    } else if (this.order === '-' + propertyName) {
      this.order = propertyName;
    } else {
      this.order = propertyName;
    }
  }

  search = () => {
    if (this.costCenterId != null && this.selectedDate != null) {
      const dateFrom = new Date(this.selectedDate[0]);
      const dateTo = new Date(this.selectedDate[1]);
      this.loadPartialReportList(dateFrom, dateTo, null, this.costCenterId);
    } else
      this._translate.get('Messages.InvalidSearchPartial').subscribe(translated => {
        this._toastrService.warning(translated);
      });
  }

  loadPartialReportList(dateFrom?: Date, dateTo?: Date, partnerId?: number, costCenterId?: number) {
    this._spinner.show();
    this.currentPageNumber = 1;
    this.lastSearchCostCenterId = this.costCenterId;
    this._reportsService.httpGetPartialReport(dateFrom, dateTo, partnerId, costCenterId)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      (data: PartialReport[]) => {
        if (data !== undefined) {
          this.partialReports = data;

          if (this.partialReports === undefined || this.partialReports.length === 0) {
            this._translate.get('Messages.NoData').subscribe(translated => {
              this._toastrService.warning(translated);
            });
          }
          this.query.totalItems = data.length;
        }
      },
      err => {
        this.partialReports = [];
        throw err;
      }
    );
  }

  private loadCostCentersItemsForDropdown() {
    this._costCenterService.httpGetUserCostCenters().subscribe(
      data => {
        if (data !== undefined) {
          this.costCenters = data;
          this.costCenters.map((cc) => { cc.costCenterIdAndName = cc.costCenterId + ' ' + cc.name; return cc; });
        }
      },
      err => {
        throw err;
      });
  }

  private showReportItem(reportItem: PartialReport) {
    if (reportItem != null) {
      this._spinner.show();

      this._reportsService.httpGetPartialReportItemAsHtml(this.lastSearchCostCenterId, reportItem.accountingId, this._translate.currentLang)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      data => {
          this.showReportItemInPrintDialog(data.toString());
      },
      err => {
        throw err;
        }
      );
    }
  }

  private showReportItemInPrintDialog(reportItemHtml: string) {
    const printMethodHtml = ' onload=window.print() ';
    const openBodyTagKeyWord = '<body';
    const positionOfHtmlBodyTag = reportItemHtml.search(openBodyTagKeyWord);

    if (positionOfHtmlBodyTag === 0) {
      return;
    }
    const positionToInsertPrintMethod = positionOfHtmlBodyTag + openBodyTagKeyWord.length;
    reportItemHtml = [reportItemHtml.slice(0, positionToInsertPrintMethod), printMethodHtml,
      reportItemHtml.slice(positionToInsertPrintMethod)].join('');

    const printFrame = window.frames['printFrame'];
    printFrame.document.write(reportItemHtml);
    printFrame.document.close();
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/partial-report/partial-report.component.ts